import React from "react"
import PropTypes from "prop-types"
import { Navigate } from "react-router-dom"
import { route, routes } from "~/helpers/routeHelper"
import { useAuth } from "~/context/auth"
import ExternalRedirect from "~/components/Shared/ExternalRedirect"
import { getSsoAppUrl } from "~/helpers/utilHelper"
import { useAccess } from "~/context/access"

const Authmiddleware = ({
  component: Component,
  componentProps,
  layout: Layout,
  isProtected,
}) => {

  const { isLoggedIn } = useAuth();
  const { iAmAdminType, getUserAppUrl } = useAccess();

  if (isProtected && !isLoggedIn()) {
    // this route is protected and the user is not logged in
    // so redirect to login
    return <ExternalRedirect to={getSsoAppUrl(`login?ret=${encodeURIComponent(window.location.href)}`)} />
  } else if (isProtected && !iAmAdminType()) {
    // this user type is not allowed access in this app
    // so redirect to his own app
    return <ExternalRedirect to={getUserAppUrl()} />
  } else if (!isProtected && isLoggedIn()) {
    // this route is public and the user is logged in
    // so redirect to homepage
    return <Navigate to={route(routes.home)} />
  }
  return <Layout>
    <Component {...componentProps} />
  </Layout>
}

Authmiddleware.propTypes = {
  isProtected: PropTypes.bool,
  component: PropTypes.any,
  componentProps: PropTypes.object,
  layout: PropTypes.any,
}

export default Authmiddleware;
